import { useMemo } from 'react';
import CategoryRadarSection from './shared/CategoryRadarSection';
import { computeRadarTickCount } from './shared/utils';
import type { IndividualMotivationCategoryBreakdown } from '@/apolloClient.types';

export interface IndividualMotivationResultProps {
    categoryBreakdowns: IndividualMotivationCategoryBreakdown[];
}

const IndividualMotivationResult = ({ categoryBreakdowns }: IndividualMotivationResultProps) => {
    const sections = useMemo(() => {
        return categoryBreakdowns.map(category => {
            const domainMax = Math.max(5, ...category.subcategoryAverages.map(s => s.maximumPossibleScore));
            const radarData = category.subcategoryAverages.map(s => ({
                shortLabel: s.subcategory,
                value: Number(s.averageScore.toFixed(2)),
            }));
            const summaryCards = category.subcategoryAverages.map(s => ({
                label: s.subcategory,
                value: Number(s.averageScore.toFixed(2)),
                total: s.maximumPossibleScore,
            }));

            return {
                title: category.category,
                statistics: {
                    domainMax,
                    radarData,
                    summaryCards,
                    tickCount: computeRadarTickCount(domainMax),
                },
            };
        });
    }, [categoryBreakdowns]);

    return (
        <div className="space-y-12">
            {sections.map(section => (
                <CategoryRadarSection
                    key={section.title}
                    title={section.title}
                    statistics={section.statistics}
                    summaryFormation={[3]}
                />
            ))}
        </div>
    );
};

export default IndividualMotivationResult;
